(function() {

    'use strict';

    angular.module('Services').factory('ClientsListsRepositoryFactory', ClientsListsRepositoryFactory);

    function ClientsListsRepositoryFactory(ClientService, $q, toastr){
        return {
            lists: {
                accounts: {
                    update:
                    function (opts) {
                        var defer = $q.defer();
                        var accounts = this;
                        if(accounts.content)
                            accounts.content.lenth = 0;
                        ClientService.Account.getAll(function(data) {
                            angular.extend(accounts, data);
                            defer.resolve(accounts);
                        }, function(error) {
                            toastr.error(error.message);
                            defer.reject(error);
                        }, opts);
                        return defer.promise;
                    }
                },
                locations: {
                    update:
                    function (opts) {
                        var defer = $q.defer();
                        var accounts = this;
                        if(accounts.content)
                            accounts.content.lenth = 0;
                        ClientService.Location.getAll(function(data) {
                            angular.extend(accounts, data);
                            defer.resolve(accounts);
                        }, function(error) {
                            toastr.error(error.message);
                            defer.reject(error);
                        }, opts);
                        return defer.promise;
                    }
                },
                groups: {
                    update:
                    function (opts) {
                        var defer = $q.defer();
                        var accounts = this;
                        if(accounts.content)
                            accounts.content.lenth = 0;
                        ClientService.Group.getAll(function(data) {
                            angular.extend(accounts, data);
                            defer.resolve(accounts);
                        }, function(error) {
                            toastr.error(error.message);
                            defer.reject(error);
                        }, opts);
                        return defer.promise;
                    }
                }

            }
        }

    }

})();


// WEBPACK FOOTER //
// ./js/services/Factories/ClientsListsRepositoryFactory.js